/* global navigator */
import { getLocationPathByLatLon } from 'Actions/locationPath';
import { updateLocation } from 'Actions/selectLocation';
import { requestGps, errorGps } from 'Actions/locations';

export const getGeolocationPermissionState = () => new Promise(
    (resolve, reject) => {
        if (navigator && navigator.permissions && navigator.geolocation) {
            return navigator.permissions.query({ name: 'geolocation' })
                .then(({ state }) => resolve(state))
                .catch(err => reject(err));
        }
        return resolve();
    }
);

export const getGeolocationPosition = () => new Promise(
    (resolve, reject) =>
        getGeolocationPermissionState().then(state => {
            if (state === 'prompt' || state === 'granted') {
                return navigator.geolocation.getCurrentPosition(
                    position => {
                        const latitude = position.coords.latitude;
                        const longitude = position.coords.longitude;

                        return resolve({ latitude, longitude });
                    },
                    error => reject(error)
                );
            }
            return reject('PERMISSION_DENIED');
        }).catch(err => reject(err))
);
/**
 * Gets the current Position of the user using the gps
 * PS: Name of function is misleading
 * @param {*} loading
 * @param {*} shouldSaveInStore
 */
export const getNearByAds = (loading = () => {}, shouldSaveInStore = true) => dispatch => {
    if (shouldSaveInStore) {
        dispatch(requestGps());
    }
    loading(true);
    return getGeolocationPosition()
        .then(({ latitude, longitude }) => {
            return dispatch(getLocationPathByLatLon({ lat: latitude, lon: longitude }))
                .then(res => {
                    loading(false);
                    const location = res && res.data && res.data.data && Array.isArray(res.data.data) && res.data.data[0];

                    return ({ ...location, gps: { latitude, longitude }});
                });
        })
        .catch(err => {
            loading(false);
            if (shouldSaveInStore) {
                dispatch(errorGps());
            }
            return Promise.reject(err);
        });
};

export const updateLocationHeader = (showLoading = () => {}, openSelectLocation = () => {}) => dispatch => {
    return getGeolocationPermissionState()
        .then(permissionState => {
            showLoading(true);
            if (permissionState === 'prompt') {
                return getGeolocationPosition().then(({ latitude, longitude }) => {
                    dispatch(getLocationPathByLatLon({ lat: latitude, lon: longitude })).then(res => {
                        const location = res && res.data && res.data.data && Array.isArray(res.data.data) && res.data.data[0];

                        showLoading(false);
                        dispatch(updateLocation(location));
                    });
                })
                    .catch(() => {
                        showLoading(false);
                        openSelectLocation(true);
                    });
            }
            showLoading(false);
            return openSelectLocation(true);
        }).catch(() => openSelectLocation(true));
};
